/**
 * @returns an object with AR audience, book level and interest level properties
 */
export function getAcceleratedReader(data) {
	const accelReader = data.FeatureContent.AcceleratedReaderInfo;
	if (accelReader) {
		return {
			audienceLevel: accelReader.audienceLevel,
			bookLevel: accelReader.bookLevel,
			interestLevel: accelReader.interestLevel
		};
	}
}



// WEBPACK FOOTER //
// ./src/data/AcceleratedReaderSelector.js